
import { informationReducer } from "../reducer/InformationReducer";

export const reducer = informationReducer;
